import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { useSwaggerClient } from '../../hooks/useSwaggerClient';
import { loginAsCustomerWithId, loginUser } from '../../actions/user';
import { useModals } from '../../hooks/useModal';

function CrossLogin({ loginUserAction, loginAsCustomer }) {
    const location = useLocation();
    const history = useHistory();
    const { showModal } = useModals();
    const [error, setError] = useState(null);
    const [shouldLoginAsGuest, setShouldLoginAsGuest] = useState(false);
    const [targetGuestId, setTargetGuestId] = useState(null);

    // Extract query parameters
    const params = new URLSearchParams(location.search);
    const crossjwt = params.get('crossjwt');
    const action = params.get('action');
    const guestId = params.get('guestId');

    // Call the cross-login API
    const [response, loading] = useSwaggerClient('auth', 'crossLogin', {
        crossjwt,
        action,
        guestId: guestId ? parseInt(guestId, 10) : undefined
    });

    useEffect(() => {
        if (!loading && response) {
            if (response.success && response.user) {
                // Store the user and token
                loginUserAction(response.user);
                localStorage.setItem('apiKey', response.user.token);

                // Check if we need to login as guest
                if (action === 'login' && guestId) {
                    setShouldLoginAsGuest(true);
                    setTargetGuestId(parseInt(guestId, 10));
                } else {
                    // Just redirect to the guest profile for viewing
                    if (response.redirect) {
                        history.push(response.redirect);
                    } else {
                        history.push('/');
                    }
                }
            } else if (response.error) {
                setError(response.error.message || 'Cross-login failed');
            }
        }
    }, [loading, response, loginUserAction, history, action, guestId]);

    // Handle login as guest after agent login is complete
    useEffect(() => {
        if (shouldLoginAsGuest && targetGuestId) {
            loginAsCustomer(targetGuestId, showModal, null, () => {
                // After logging in as guest, redirect to their profile
                history.push(`/guests/${targetGuestId}`);
            });
        }
    }, [shouldLoginAsGuest, targetGuestId, loginAsCustomer, showModal, history]);

    useEffect(() => {
        if (!crossjwt) {
            setError('Missing cross-login token');
        }
    }, [crossjwt]);

    if (error) {
        return (
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                style={{ minHeight: '100vh' }}
            >
                <Grid item>
                    <Typography variant="h5" color="error">
                        {error}
                    </Typography>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
            <Grid item>
                <CircularProgress />
                <Typography variant="h6" style={{ marginTop: 20 }}>
                    Logging in...
                </Typography>
            </Grid>
        </Grid>
    );
}

const mapDispatchToProps = dispatch => ({
    loginUserAction: user => dispatch(loginUser(user)),
    loginAsCustomer: (customerId, showModal, onError, onSuccess) =>
        dispatch(loginAsCustomerWithId(customerId, showModal, onError, onSuccess))
});

export default connect(null, mapDispatchToProps)(CrossLogin);
